import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

const scroll = ScrollTrigger => {
  const lenis = new Lenis();

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  lenis.on('scroll', ScrollTrigger.update);
};
export default scroll;
